import {
  CustomFieldEntityEnum,
  CustomFieldStatusEnum,
  CustomFieldTypeEnum,
  ICustomFieldResSchema,
} from '@monetize/types/app';
import { MText } from '../../../../components/Monetize';
import { createColumnHelper } from '../../../../components/Monetize/DataTableNew/appTable';
import {
  ColumnCatalog,
  ColumnContextBase,
} from '../../../../components/Monetize/DataTableNew/columnCatalog/types';
import {
  enumDisplayBodyTemplate,
  getColHeaderFilters,
  getColHeaderWithSize,
  getColumnFilterValuesForEnum,
  textBodyTemplate,
} from '../../../../components/Monetize/DataTableNew/tableUtilsNew';
import {
  CUSTOM_FIELD_ENTITY_DISPLAY,
  CUSTOM_FIELD_STATUS_DISPLAY,
  CUSTOM_FIELD_TYPE_DISPLAY,
  CUSTOM_FIELD_VISIBILITY_DISPLAY,
} from '../../../../constants/customFields';
import { getCustomFieldVisibilityDisplay } from '../../../../utils/customFields';

const columnHelper = createColumnHelper<ICustomFieldResSchema>();

export type CustomFieldsListColumnContext =
  ColumnContextBase<ICustomFieldResSchema>;

/** tableId: FilterStateKeys.CUSTOM_FIELDS_LIST */
export const CUSTOM_FIELDS_LIST_CATALOG: ColumnCatalog<
  ICustomFieldResSchema,
  CustomFieldsListColumnContext
> = [
  {
    id: 'entity',
    label: 'Object',
    build: () =>
      columnHelper.accessor('entity', {
        ...getColHeaderWithSize('Object', 180),
        ...getColHeaderFilters('SET', {
          predefinedFilterValues: getColumnFilterValuesForEnum(
            CustomFieldEntityEnum,
            CUSTOM_FIELD_ENTITY_DISPLAY,
          ),
        }),
        cell: enumDisplayBodyTemplate({
          displayMap: CUSTOM_FIELD_ENTITY_DISPLAY,
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'displayLabel',
    label: 'Label',
    customizable: false,
    build: () =>
      columnHelper.accessor('displayLabel', {
        ...getColHeaderWithSize('Label', 200),
        ...getColHeaderFilters('TEXT'),
        cell: textBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'key',
    label: 'API Name',
    build: () =>
      columnHelper.accessor('key', {
        ...getColHeaderWithSize('API Name', 200),
        ...getColHeaderFilters('TEXT'),
        cell: textBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'type',
    label: 'Type',
    build: () =>
      columnHelper.accessor('type', {
        ...getColHeaderWithSize('Type', 150),
        ...getColHeaderFilters('SET', {
          predefinedFilterValues: getColumnFilterValuesForEnum(
            CustomFieldTypeEnum,
            CUSTOM_FIELD_TYPE_DISPLAY,
          ),
        }),
        cell: enumDisplayBodyTemplate({
          displayMap: CUSTOM_FIELD_TYPE_DISPLAY,
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'status',
    label: 'Status',
    build: () =>
      columnHelper.accessor('status', {
        ...getColHeaderWithSize('Status', 150),
        ...getColHeaderFilters('SET', {
          predefinedFilterValues: getColumnFilterValuesForEnum(
            CustomFieldStatusEnum,
            CUSTOM_FIELD_STATUS_DISPLAY,
          ),
        }),
        cell: enumDisplayBodyTemplate({
          displayMap: CUSTOM_FIELD_STATUS_DISPLAY,
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'visibility',
    label: 'Visibility',
    build: () =>
      columnHelper.display({
        id: 'visibility',
        ...getColHeaderWithSize('Visibility', 150),
        cell: ({ row }) => (
          <MText lineClamp={1}>
            {
              CUSTOM_FIELD_VISIBILITY_DISPLAY[
                getCustomFieldVisibilityDisplay(row.original.permissionsConfig)
              ]
            }
          </MText>
        ),
        enableSorting: false,
      }),
  },
];
